/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ExtraProps = {
	projectKey: string;
};

type PlaybooksHorizontalNavEntrypointComponent = EntryPointComponent<{}, {}, {}, ExtraProps>;

const playbooksHorizontalNavEntrypoint: EntryPoint<
	PlaybooksHorizontalNavEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<PlaybooksHorizontalNavEntrypointComponent>(
		/* webpackChunkName: "async-spa-apps-playbooks-horizontal-nav" */ './index.tsx',
	),
	getPreloadProps: ({ context: { match } }: EntryPointRouteParams) => {
		// Extract projectKey from route parameters
		const projectKey = match.params.projectKey;

		if (!projectKey) {
			throw new Error('projectKey is required');
		}

		return {
			extraProps: {
				projectKey,
			},
		};
	},
});

export default playbooksHorizontalNavEntrypoint;
